var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M13.988 2A12 12 0 1 0 26 14 11.994 11.994 0 0 0 13.988 2zM22.3 9.2h-3.54a18.779 18.779 0 0 0-1.656-4.272A9.636 9.636 0 0 1 22.3 9.2zM14 4.448A16.9 16.9 0 0 1 16.292 9.2h-4.584A16.9 16.9 0 0 1 14 4.448zM4.712 16.4a9.387 9.387 0 0 1 0-4.8h4.056A19.818 19.818 0 0 0 8.6 14a19.818 19.818 0 0 0 .168 2.4zm.988 2.4h3.54a18.779 18.779 0 0 0 1.656 4.272A9.584 9.584 0 0 1 5.7 18.8zm3.54-9.6H5.7a9.584 9.584 0 0 1 5.2-4.272A18.779 18.779 0 0 0 9.236 9.2zM14 23.552a16.9 16.9 0 0 1-2.292-4.752h4.584A16.9 16.9 0 0 1 14 23.552zm2.808-7.152h-5.616A17.655 17.655 0 0 1 11 14a17.5 17.5 0 0 1 .192-2.4h5.616A17.5 17.5 0 0 1 17 14a17.655 17.655 0 0 1-.192 2.4zm.3 6.672a18.779 18.779 0 0 0 1.656-4.272H22.3a9.636 9.636 0 0 1-5.192 4.272zm2.124-6.672A19.819 19.819 0 0 0 19.4 14a19.819 19.819 0 0 0-.168-2.4h4.056a9.387 9.387 0 0 1 0 4.8z",
    transform: "translate(-2 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorld);
export default __webpack_public_path__ + "static/media/icon-world.7b251125.svg";
export { ForwardRef as ReactComponent };